export const HomePage = () => {
  return (
    <div className="App">
      <h3>Pet Owner Booking</h3>
      <p>{process.env.NODE_ENV}</p>
    </div>
  )
}
